<template>
  <div>
    <div>
      <div v-if="isMobile">
        <app-details
          v-for="index in ayins.length"
          :key="index"
          :index="index - 1"
          :ayin="ayins[index - 1]"
          :selectedIndex="selectedIndex"
          @clicked="onClickAyin"
          :showDetails="showDetails"
        >
        </app-details>
      </div>
      <div v-else>
        <v-data-table
          :items="ayins"
          :headers="ayinHeaders"
          item-key="id"
          class="elevation-1 rounded"
          show-expand
          single-expand
          :no-data-text="tableText"
          :item-class="rowClass"
          :footer-props="{
            itemsPerPageAllText: 'همه',
            itemsPerPageText: 'تعداد ردیف',
          }"
        >
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <b>توضيحات: </b>
              <span v-html="convertHTMLBody(item.description)"></span>
              <br />
            </td>
          </template>
          <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
            از {{ pageStart }} تا {{ pageStop }}
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import { getAyinNamehDetails } from "@/api/aboutus";
import DetailsApp from "./AyinDetailsApp";
import { convertHTMLBody } from "@/utils/constants";

export default {
  components: {
    appDetails: DetailsApp,
  },
  data() {
    return {
      ayinHeaders: [
        {
          text: "عنوان",
          value: "ayinSubject",
          width: "40%",
        },
        {
          text: "نام آیین نامه",
          value: "ayinName",
          width: "35%",
        },
        {
          text: "جنسیت",
          value: "jensiat",
          width: "10%",
        },
        {
          text: "مقطع",
          value: "maqta",
          width: "10%",
        },
        { text: "توضیحات", value: "data-table-expand", width: "5%" },
      ],
      showModal: false,
      scrollY: 0,
      selectedIndex: -1,
      showDetails: false,
      ayins: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    tableText() {
      return this.$store.getters.tableText;
    },
  },
  created() {
    this.getAyinDetails();
  },
  methods: {
    convertHTMLBody,
    goToRoute(route) {
      window.scrollTo(0, 0);
      if (route.search("/") == 0) {
        this.$router.push(route);
      } else {
        window.open(route);
      }
    },
    hideModal() {
      this.showModal = false;
    },
    getAyinDetails() {
      if (!this.$route.params.id) {
        return null;
      }
      this.$store.commit("SET_TABLE_TEXT", true);
      const serial = this.$route.params.id;
      getAyinNamehDetails(serial)
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_TABLE_TEXT", false);
          if (data) {
            this.ayins = data;
          } else if (this.isMobile)
            this.$store.commit("SET_SNACKBAR_TEXT", "داده ای وجود ندارد.");
        })
        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },
    rowClass(item) {
      let rowClass = item.description === "" ? "no-expand" : "";
      return rowClass;
    },
    onClickAyin(index) {
      this.$store.commit("SET_SNACKBAR_SHOW", false);
      this.selectedIndex = index;
      if (this.ayins[this.selectedIndex].description === "") {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "جزییاتی برای نمایش وجود ندارد."
        );
        this.showDetails = false;
      } else {
        this.showDetails = true;
      }
    },
  },
};
</script>
<style>
.directionLTR {
  direction: ltr;
}
</style>
